// extracted by css-extract-rspack-plugin
export default {"itemCell":"itemCell-iPCkHK","itemTitle":"itemTitle-N1fhtz","listHeaderTitle":"listHeaderTitle-Bkit1U"};